import { useLanguage } from '@/i18n/LanguageContext'
import { SectionHeading } from '@/components/ui/SectionHeading'
import { ProcessScrollJourney } from './ProcessScrollJourney'

/**
 * #proces — Phase 4, upgraded to a scroll-driven "journey" (see
 * ProcessScrollJourney.tsx for the full spec: a UFO hops card to card on
 * desktop, a larva that turns into a butterfly crawls a vertical track on
 * mobile). No dedicated nav anchor, matching the live site.
 *
 * The heading is passed INTO ProcessScrollJourney rather than rendered here
 * above it: on desktop it used to sit in normal document flow before the
 * pinned scroll section, which meant it scrolled out of view the moment the
 * pin engaged, leaving the sticky viewport feeling empty above the cards
 * while the UFO hopped. Now it renders inside the sticky viewport itself on
 * desktop, so it stays in sight for the whole journey. Mobile isn't pinned
 * at all (see ProcessScrollJourney.tsx's file header for why), so there the
 * heading just scrolls normally above the track/cards like any other
 * content — kept in the same prop for one shared call site regardless.
 */
export function ProcessSection() {
  const { t } = useLanguage()

  return (
    <section id="proces" className="pt-16 pb-0 md:pt-20 md:pb-2">
      <ProcessScrollJourney
        heading={<SectionHeading title={t('how-title')} subtitle={t('how-sub')} />}
      />
    </section>
  )
}
